import { createBrowserRouter } from "react-router-dom"
import PrivateRoutes from "./PrivateRoutes"
import Login from "../pages/login/Login"
import AccessManagement from "../pages/user-management/AccessManagement"
import SearchEntity from "../pages/search/SearchEntity"
import ChangePassword from "../pages/change-password/ChangePassword"
import PrivilegeRoutes from "./PrivilegeRoutes"
import { Privilege } from "../core/constants/privilege"
import NotAuthorized from "../pages/not-authorized/NotAuthorized"

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "",
      element: <PrivateRoutes />,
      children: [
        { path: "not-authorized", element: <NotAuthorized /> },
        {
          path: "search",
          element: <PrivilegeRoutes component={< SearchEntity />} privilege={Privilege[Privilege.SEARCH_ENTITY]} />
        },
        {
          path: "access-management",
          element: <PrivilegeRoutes component={<AccessManagement />} privilege={Privilege[Privilege.USER_MANAGEMENT]} />
        },
        { path: "change-password", element: <ChangePassword /> },
      ],
    },
  ],
  { basename: process.env.PUBLIC_URL },
)
export default router
